/*jshint esversion: 9 */
import { mapGetters, mapActions } from 'vuex';
import StandardDialogFullScreen from '@/components/StandardComponents/StandardDialogFullScreen.component.vue';
import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue';
import StandardStep from '@/components/StandardComponents/StandardStep.component.vue';
import StandardStepAdd from '@/components/StandardComponents/StandardStepAdd.component.vue';
import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue';
import StandardDeleteButton from '@/components/StandardComponents/StandardDeleteButton.component.vue';
import StatisticsBeam from '@/components/ProjectTaktPlan/StatisticsBeam.component.vue';
import StatisticsTakt from '@/components/ProjectTaktPlan/StatisticsTakt.component.vue';
import TText from '@/components/Taktify/TText.component.vue'
import Activator from '@/components/ProjectTaktPlan/Activator.component.vue';
import WorkBenchWorkPackageAverageLine from '@/components/WorkBench/WorkBenchWorkPackageAverageLine.component.vue';
import AIIcon from '@/components/WorkBench/AIIcon.component.vue';
import WorkBenchWorkPackage from '@/components/WorkBench/WorkBenchWorkPackage.component.vue';
import WorkBenchWaggon from '@/components/WorkBench/WorkBenchWaggon.component.vue';
import WorkBenchSequenceWaggonTab from '@/components/WorkBench/WorkBenchSequenceWaggonTab.component.vue';
import WorkBenchWorkPackageHeader from '@/components/WorkBench/WorkBenchWorkPackageHeader.component.vue';
import WorkBenchWorkPackageTab from '@/components/WorkBench/WorkBenchWorkPackageTab.component.vue';
import WorkBenchWorkPackageColorPicker from '@/components/WorkBench/WorkBenchWorkPackageColorPicker.component.vue';
import WorkBenchWorkPackageIconPicker from '@/components/WorkBench/WorkBenchWorkPackageIconPicker.component.vue';

import StandardDeleteBtn from '@/components/StandardComponents/StandardDeleteBtn.component.vue';
import CommunitySuggestBtn from '@/components/Community/CommunitySuggestBtn.component.vue';

import TUploadButton from '@/components/Taktify/TUploadButton.component.vue';

import WorkBenchSequenceWaggonWorkPackage from '@/components/WorkBench/WorkBenchSequenceWaggonWorkPackage.component.vue';

import draggable from "vuedraggable";

export const WorkBenchWorkPackageMixin = {
  components: {
    draggable,
    StandardDialogFullScreen,
    StandardFlexBox,
    StandardStep,
    StandardStepAdd,
    StandardDataField,
    StandardDeleteButton,
    StatisticsBeam,
    StatisticsTakt,
    TText,
    Activator,
    WorkBenchWorkPackageAverageLine,
    AIIcon,
    WorkBenchWorkPackage,
    WorkBenchWorkPackageHeader,
    WorkBenchWorkPackageTab,
    WorkBenchWorkPackageColorPicker,
    WorkBenchWorkPackageIconPicker,
    WorkBenchWaggon,
    WorkBenchSequenceWaggonTab,
    StandardDeleteBtn,
    CommunitySuggestBtn,

    TUploadButton,

    WorkBenchSequenceWaggonWorkPackage,
  },
  data: () => ({
    ai_animation: false,
    ai_animation_suggestion: false,
    selected_step_type: '',
    selected_more_type: 'costs',
    bottom_bar: {
      show: false,
      content: ''
    },
    focus_page: 'attributes',
    add_step: false,
    edit_step: false,
    edit_id: -1,
    edit_index: -1,
    step_text: "",
    edit_step_templates: false,
    update_key_add_step: 0,
    draggable_steps: false,
    //images
    update_key_add_image: 0,
    new_image: {
      file: false,
      local_url: false,
      name: false,
      comment: '',
    },
    new_image_id: 0,
    //hashtags
    update_key_add_hashtag: 0,
  }),
  created() {
    // this.selected_step_type = `${this.prefix}${this.prefix_two}worksteps`;
    this.selected_step_type = `${this.prefix_one_step}${this.prefix_two_step}worksteps`;
    let self = this;
    setTimeout(function () {
      self.ai_animation = false;
    }, 5000);
  },
  mounted() {
    if (this.$refs.image_flex_box) {
      let self = this;
      setTimeout(function () {
        self.$refs.image_flex_box.$el.scroll({top: self.$refs.image_flex_box.$el.scrollHeight, left: 0, behavior: 'smooth'});
      }, 500);
    }
  },
  watch: {
    'bottom_bar.show': function(val) {
      if (val) {
        this.ai_animation_suggestion = true;
        let self = this;
        setTimeout(function () {
          self.ai_animation_suggestion = false;
        }, 3000);
      } else {
        this.ai_animation_suggestion = false;
      }
    },
    'bottom_bar.content': function(val) {
      if (this.bottom_bar.show) {
        this.ai_animation_suggestion = true;
        let self = this;
        setTimeout(function () {
          self.ai_animation_suggestion = false;
        }, 3000);
      }
      if (this.bottom_bar.show && val.substring(val.length-5, val.length) === 'steps') {
        this.requestWBObject({
          url: [
            {[val.substring(`${this.prefix_one_step}${this.prefix_two_step}`.length)]: ''},
            {showWithEntitiesNormalized: ''},
          ]
        });
      }
    },
    'work_package.token': function() {
      this.getAIRecommendations();
    },
    'work_package.color': function() {
      this.getAIRecommendations();
    },
    'work_package.icon': function() {
      this.getAIRecommendations();
    },
  },
  computed: {
    prefix(){
      if (this.$route.params.info_box_template_type) {
        switch (this.$route.params.info_box_template_type) {
          case 'custom':
          return '';
          case 'company':
          return 'b';
          case 'community':
          return 'c';
        }
      } else {
        switch (this.$route.params.template_type) {
          case 'custom':
          return '';
          case 'company':
          return 'b';
          case 'community':
          return 'c';
        }
      }
      return '';
    },
    prefix_two_wp(){
      if (
        this.$route.params.workpackage_id &&
        this.$route.params.workpackage_id !== 'create' &&
        !this.$route.params.info_box_template_type &&
        this.$route.fullPath.includes('sequences')
      ) {
        return 's';
      }
      if (
        this.$route.params.workpackage_id &&
        this.$route.params.workpackage_id !== 'create' &&
        !this.$route.params.info_box_template_type &&
        this.$route.fullPath.includes('waggons') &&
        !this.$route.fullPath.includes('taktplan') // better solution needed!!!
      ) {
        return 'wag';
      }
      if (
        ( this.$route.params.workpackage_id && this.$route.fullPath.includes('workpackages') ) ||
        this.$route.params.workpackage_id === 'create' ||
        this.$route.params.info_box_template_type
      ) {
        return '';
      }
      return '';
    },
    prefix_one_step(){
      if ( this.$route.params.workpackage_id === 'create' ) {
        return '';
      } else {
        return this.prefix;
      }
    },
    prefix_two_step(){
      if (
        this.$route.params.workpackage_id !== 'create' &&
        !this.$route.params.info_box_template_type &&
        this.$route.fullPath.includes('sequences')
      ) {
        return 's';
      }
      if (
        this.$route.params.workpackage_id !== 'create' &&
        !this.$route.params.info_box_template_type &&
        this.$route.fullPath.includes('waggons') &&
        !this.$route.fullPath.includes('taktplan') // better solution needed!!!
      ) {
        return 'wag';
      }
      if (
        ( this.$route.fullPath.includes('workpackages') ) ||
        this.$route.params.workpackage_id === 'create' ||
        this.$route.params.info_box_template_type ||
        this.$route.fullPath.includes('taktplan') // better solution needed!!!
      ) {
        return 'w';
      }
      return '';
    },
    work_package(){
      if ( this.$route.params.sequence_id === 'create' ) {
        if ( this.$route.params.workpackage_id === 'create' ) {
          return this.$store.getters['WorkBenchLocal/getWBLObject']({
            path: [
              {workpackage: ''},
            ]
          });
        } else {
          return this.$store.getters['WorkBenchLocal/getWBLObject']({
            path: [
              {sequence: ''},
              {swaggons: this.$route.params.waggon_id},
              {sworkpackages: this.$route.params.workpackage_id},
            ]
          });
        }
      } else if (this.$route.params.workpackage_id === 'create') {
        return this.$store.getters['WorkBenchLocal/getWBLObject']({
          path: [
            {workpackage: ''},
          ]
        });
      } else {
        return this.$store.state.WorkBench[`${this.prefix}${this.prefix_two_wp}workpackages`][parseInt(this.$route.params.workpackage_id)]
      }
    },
    waggon(){
      if (this.$route.params.waggon_id === 'create') {
        return this.$store.getters['WorkBenchLocal/getWBLObject']({
          path: [
            {waggon: ''},
          ]
        });
      } else {
        return this.$store.state.WorkBench[`${this.prefix}waggons`][parseInt(this.$route.params.waggon_id)]
      }
    },
    wpr() {
      let recommendation = this.getWBObject({
        type: 'workpackagerecommendations',
        id: this.create?-1:this.work_package_id,
      });
      if (recommendation) {
        return recommendation;
      } else {
        return {
          time_effort_planned: 0,
          manpower_planned: 0,
          quantity_value: 0,
          wdefectsteps_counts: 0,
          wdesignsteps_counts: 0,
          whandoversteps_counts: 0,
          wlogisticsteps_counts: 0,
          wqualitysteps_counts: 0,
          wworksteps_counts: 0,
        };
      }
    },
    ...mapGetters('WorkBench', [
      'getWBObject',
      'getWBObjects',
      'getWBObjectsFiltered',
    ]),
    ...mapGetters('WorkPackage', [
      'getAverageAi',
      'getNewIcon',
      'getWorkPackageIcons'
    ]),
    ...mapGetters('Auth', [
      'getUserId'
    ]),
  },
  methods: {
    getAIRecommendations() {
      this.ai_animation = true;
      let self = this;
      setTimeout(function () {
        self.ai_animation = false;
      }, 2000);
      // this.createWBObject({
      //   url: [
      //     {ai: 'workpackagerecommendations'},
      //   ],
      //   wb_object: {
      //     id: this.work_package.id,
      //     color: this.work_package.color,
      //     token: this.work_package.token,
      //     icon: this.work_package.icon,
      //   }
      // });
    },
    ...mapActions('Ultra', [
      'createUObject',
    ]),
    ...mapActions('WorkBench', [
      'requestWBObject',
      'createWBObject',
      'updateWBObject',
      'updateWBObjectHashtags',
      'deleteWBObject',
      'changeWBObjectPosition',
    ]),
    ...mapActions('WorkBenchLocal', [
      'createWBLObject',
      'updateWBLObject',
      'deleteWBLObject',
      'resetWorkpackage'
    ]),
    stepFlexBoxScrollBottom() {
      if (this.$refs.step_flex_box) {
        let self = this;
        setTimeout(function () {
          self.$refs.step_flex_box.$el.scroll({top: self.$refs.step_flex_box.$el.scrollHeight, left: 0, behavior: 'smooth'});
        }, 500);
      }
    },
    selectWorkpackageImage(image) {
      this.new_image.file = image;
      this.new_image.local_url = URL.createObjectURL(image);
      this.new_image.name = image.name;
      this.update_key_add_image++;
    },
    uploadWorkpackageImage() {
      if (this.new_image.file) {
      let image = new FormData();
      image.append("image", this.new_image.file);


      let url = [];

      if (this.sequence_id) {
        url = [
          {[`${this.prefix}sequences`]: this.sequence_id},
          {[`${this.prefix}swaggons`]: this.waggon_id},
          {[`${this.prefix}sworkpackages`]: this.work_package_id},
          {[`${this.prefix}${this.prefix_two_wp !== 'w'?this.prefix_two_wp:''}workpackageimages`]: ''},
          {showWithEntitiesNormalized: ''}
        ];
      } else {
        url = [
          {[`${this.prefix}workpackages`]: this.work_package_id},
          {[`${this.prefix}${this.prefix_two_wp === '' ? 'w' : this.prefix_two_wp }workpackageimages`]: ''},
          {showWithEntitiesNormalized: ''}
        ];
      }

      if (this.prefix_two === 'wag') {
        url = [
          {[`${this.prefix}waggons`]: this.waggon_id},
          {[`${this.prefix}wagworkpackages`]: this.work_package_id},
          {[`${this.prefix}${this.prefix_two_wp !== 'w'?this.prefix_two_wp:''}workpackageimages`]: ''}
        ];
      }

      this.createWBObject({
        url: url,
        wb_object: image,
      }).then(id => {

        let url_2 = [];

        if (this.sequence_id) {
          url_2 = [
            {[`${this.prefix}sequences`]: this.sequence_id},
            {[`${this.prefix}swaggons`]: this.waggon_id},
            {[`${this.prefix}sworkpackages`]: this.work_package_id},
            {[`${this.prefix}${this.prefix_two_wp !== 'w'?this.prefix_two_wp:''}workpackageimages`]: id}
          ];
        } else {
          url_2 = [
            {[`${this.prefix}workpackages`]: this.work_package_id},
            {[`${this.prefix}${this.prefix_two_wp === '' ? 'w' : this.prefix_two_wp }workpackageimages`]: id},
          ];
        }

        if (this.prefix_two === 'wag') {
          url_2 = [
            {[`${this.prefix}waggons`]: this.waggon_id},
            {[`${this.prefix}wagworkpackages`]: this.work_package_id},
            {[`${this.prefix}${this.prefix_two_wp !== 'w'?this.prefix_two_wp:''}workpackageimages`]: id}
          ];
        }
        this.updateWBObject({
          url: url_2,
          update: {
            comment: this.new_image.comment
          },
        }).then(() => {
          this.new_image = {
            file: false,
            local_url: false,
            name: false,
            comment: '',
          };
          this.update_key_add_image++;
        });
      });
      }
    },
    uploadWorkpackageImageBulk(id) {
      const promises = [];
      for (let i = 0; i < this.work_package[`${this.prefix_one_step}${this.prefix_two_step}workpackageimages`].length; i++) {
        let image = new FormData();
        image.append("image", this.work_package[`${this.prefix_one_step}${this.prefix_two_step}workpackageimages`][i].file);
        promises.push(this.createWBObject({
          url: [
            {workpackages: id},
            {[`${this.prefix}${this.prefix_two_step}workpackageimages`]: ''},
            {showWithEntitiesNormalized: ''}
          ],
          wb_object: image,
        }));
      }
      Promise.all(promises)
      .then((resp) => {
        const promises_two = [];
        for (let i = 0; i < resp.length; i++) {
          promises_two.push(this.updateWBObject({
            url: [
              {[`${this.prefix}${this.prefix_two_wp}workpackages`]: id},
              {[`${this.prefix}${this.prefix_two_step}workpackageimages`]: resp[i]}
            ],
            update: {
              comment: this.work_package[`${this.prefix}${this.prefix_two_step}workpackageimages`][i].comment
            },
          }));
        }
        Promise.all(promises_two)
        .then(() => {
          this.$router.push({
            name: this.nav_back?this.nav_back:'WorkBenchWorkPackages'
          });
        });
      });
    },
    addHashtag(evt) {
      let hashtags = JSON.parse(JSON.stringify(this.work_package.hashtags));
      hashtags.push({tag: evt.replace(/\s/g,'')});
      this.updateWBObjectHashtags({
        url: [
          {[`${this.prefix}${this.prefix_two_wp}workpackages`]: this.work_package_id},
        ],
        update: {
          hashtags: hashtags
        }
      });
      this.update_key_add_hashtag++;
    },
    removeHashtag(index) {
      let hashtags = JSON.parse(JSON.stringify(this.work_package.hashtags));
      hashtags.splice(index, 1);
      this.updateWBObjectHashtags({
        url: [
          {[`${this.prefix}${this.prefix_two_wp}workpackages`]: this.work_package_id},
        ],
        update: {
          hashtags: hashtags
        }
      });
    },
    getUnlikes(likes) {
      let likes_copy = JSON.parse(JSON.stringify(likes));
      likes_copy.splice(likes_copy.findIndex(like => like.user.id === this.getUserId), 1);
      return likes_copy;
    },
    getLikes(likes) {
      let likes_copy = JSON.parse(JSON.stringify(likes));
      likes_copy.push({
        user: {
          id: this.getUserId
        }
      });
      return likes_copy;
    }
  }
};
